import React from 'react'
import authConfig from "../../config/authConfig";
import globals from "../../config/appconfig";
import Button from "../../components/button/Button";
import history from "../../utils/History"

export default class LoginSelect extends React.Component {

    onClickButton(appName) {
        sessionStorage.setItem("selectedApp", appName);
        if (appName === "HIV")
            history.push(new URL(authConfig["url-redirect-home-hiv"]).pathname);
        else
            history.push(new URL(authConfig["url-redirect-home"]).pathname);
    }

    render() {
        return (
            <div>
                <div className={"container"} style={{display: "flex", justifyContent: "center", marginTop: "5rem"}}>
                    <p style={{
                        fontSize: "20px",
                        textAlign: "center"
                    }}>
                        <strong>Scegli dove vuoi lavorare:</strong>
                        <br/>
                        <Button
                            id={"sirmi"}
                            className="btnWhite"
                            text={"SIRMI"}
                            style={{ height: "3rem", marginTop: "1rem" }}
                            onClick={() => this.onClickButton("SIRMI")}/>
                        <br/>
                        <Button
                            id={"hiv"}
                            className="btnWhite"
                            text={"Sorveglianza HIV"}
                            style={{ height: "3rem", marginTop: "1rem" }}
                            onClick={() => this.onClickButton("HIV")}
                            disabled={globals["attivazione-sorveglianza-hiv"] === "false"}
                        />
                    </p>
                </div>

            </div>
        );
    }
}